import React, { useEffect, useRef } from "react";
import * as componentStyle from './linkedInFollowButton.module.scss';

type LinkedInFollowButtonProps = {
  companyId?: string; // Your LinkedIn company ID
  counter?: "right" | "top" | ""; // Optional counter display
}

declare global {
  interface Window {
    IN?: {
      parse: () => void;
    };
  }
}

export default function LinkedInFollowButton({companyId = '13703292', counter = "right"}: LinkedInFollowButtonProps) {
  const scriptLoaded = useRef(false);

  useEffect(() => {
    // Only load the script once
    if (!window.IN && !scriptLoaded.current) {
      const script = document.createElement("script");
      script.src = "https://platform.linkedin.com/in.js";
      script.type = "text/javascript";
      script.async = true;
      script.innerHTML = "lang: en_US";
      document.body.appendChild(script);
      scriptLoaded.current = true;

      script.onload = () => {
        window.IN?.parse();
      };
    } else {
      // If already loaded, just re-parse
      window.IN?.parse();
    }
  }, []);

  return (
    <div className={componentStyle.linkedInFollowButton}>
      <div className={componentStyle.linkedInFollowButton__box}>
        <p className={componentStyle.linkedInFollowButton__paragraph}>Follow us on LinkedIn for more <br/>updates and stories</p>
        <div className={componentStyle.linkedInFollowButton__mainButton}>
          <script
            type="IN/FollowCompany"
            data-id={companyId}
            data-counter={counter}
          ></script>
        </div>
      </div>
    </div>
  );
};

